import { DIVISIONS_LIST } from 'constants';
import actions from '../actions/actionTypes';

export const INITIAL_STATE = {
  loading: false,
  error: null,
  optionsData: {
    designers: [],
    departments: [],
  },
};

const mapDesignerTitles = (designerList = []) =>
  designerList.map((designer) => {
    return { ...designer, title: designer.key };
  });

const mapDivisionCodeToDepartmentName = (divisionList = []) =>
  divisionList.map((item) => ({ ...item, value: DIVISIONS_LIST[item.key] }));

const salesFilters = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actions.PERF_FILTER_OPTIONS_LOADING:
      return {
        ...state,
        loading: true,
      };

    case actions.PERF_FILTER_OPTIONS_SUCCESS:
      return {
        ...state,
        optionsData: {
          ...state.data,
          designers: mapDesignerTitles(payload.designers),
          departments: mapDivisionCodeToDepartmentName(payload.departments),
        },
        loading: false,
      };

    case actions.PERF_FILTER_OPTIONS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default salesFilters;
